import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id found');
        navigate('/cms/login');
        return;
      }

      try {
        const API_URL = process.env.REACT_APP_BACKEND_URL;
        
        const response = await fetch(`${API_URL}/api/auth/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          throw new Error('Auth failed');
        }

        const user = await response.json();
        
        // Clear URL fragment and navigate to dashboard
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/cms', { state: { user } });
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/cms/login');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-muted-foreground text-sm uppercase tracking-widest">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
